import DepsService from 'services/dependencies';

const CONTEXT = 'app';

export const fetchBeAppVersion = async () => {
  const url = DepsService.rest.appVersion.backend.url;
  const queryParams = {};
  const urlParams = {};
  return DepsService.restSrv.get(CONTEXT, url, queryParams, urlParams);
};



// WEBPACK FOOTER //
// ./src/modules/utils/rw-app-version/resources/app-version.api.js